<template><div><h1 id="technische-funktionen" tabindex="-1"><a class="header-anchor" href="#technische-funktionen"><span>Technische Funktionen</span></a></h1>
<p>Technische Funktionen — Stammtabelle der Technischen Funktionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die technischen Funktionen definiert. Die Einträge werden von Arenae Consulting AG verwaltet.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Technische Funktionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Programm</dt>
<dd>Programmname</dd>
<dt>Variablen</dt>
<dd>Programm-Variablen</dd>
<dt>Bezeichnung</dt>
<dd>Beschreibung der Funktion</dd>
<dt>Funktion</dt>
<dd>Zugeordnete <a class="link" href="ft.refdata.benutzerfunktionen.html" title="Benutzerfunktionen">Benutzerfunktion</a></dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


